export default "__VITE_ASSET__De6lU7qO__"